import {
  Drawer as SuiDrawer,
  DrawerProps as SuiDrawerProps,
} from '@saas-ui/react';

import { DrawerTitle } from './DrawerTitle';

// A drawer that draws its own header passes no title, so the header stays hidden.
type DrawerProps = Omit<SuiDrawerProps, 'title'> & {
  title?: SuiDrawerProps['title'];
  description?: React.ReactNode;
  hideCloseButton?: boolean;
};

export function Drawer({
  children,
  description,
  hideCloseButton,
  title,
  headerProps,
  ...props
}: DrawerProps) {
  const showHeader = title != null && title !== '';

  return (
    <SuiDrawer
      {...props}
      title={
        showHeader ? (
          <DrawerTitle
            title={title}
            description={description}
            hideCloseButton={hideCloseButton}
            onClose={props.onClose}
          />
        ) : undefined
      }
      hideCloseButton={showHeader ? !hideCloseButton : true}
      headerProps={
        showHeader
          ? headerProps
          : {
              display: 'none',
              p: 0,
              borderBottomWidth: 0,
              minH: 0,
              ...headerProps,
            }
      }
    >
      {children}
    </SuiDrawer>
  );
}
